import React from 'react';
import { CloseableModal } from '../../../../../components/CloseableModal';
import { CandidateSummary } from '../../../../../services/applicant_tracking/CandidateService';
import { DraftCandidateBody } from './DraftCandidateBody';
import { ExistingCandidateBody } from './ExistingCandidateBody';

interface PropTypes {
  candidateId: number;
  referralFlow?: boolean;
  candidateSummary: CandidateSummary | null;
  onClose: () => void;
}

export function NewJobApplicationModal(props: PropTypes) {
  const isDraft = props.candidateSummary?.candidateStatus === 'draft';

  const headerTitle = isDraft
    ? 'Candidate Exists as Draft'
    : 'Candidate Already Exists';

  return (
    <CloseableModal
      keyboard
      backdrop
      className='modal-dialog-centered'
      onClose={props.onClose}
      isOpen={props.candidateId !== null && props.candidateSummary !== null}
      size='md'
      headerTitle={headerTitle}
      bodyChildren={
        props.candidateSummary &&
        (isDraft ? (
          <DraftCandidateBody
            candidateId={props.candidateId}
            referralFlow={props.referralFlow}
            onClose={props.onClose}
          />
        ) : (
          <ExistingCandidateBody
            candidateId={props.candidateId}
            referralFlow={props.referralFlow}
            applicationsCount={props.candidateSummary.applicationsCount}
            recentApplicationId={props.candidateSummary.recentApplicationId}
            applicationJobTitles={props.candidateSummary.applicationJobTitles}
            onClose={props.onClose}
          />
        ))
      }
    />
  );
}
